import './NavBar.css';
import {useEffect, useRef, useState} from 'react';
import Calendar from  './Calender.js';
function NavigationBar(props){
    const [day,setDay] = useState(props.activeDate.day);

    let [month, setMonth] = useState(props.activeDate.month);
    let [year, setYear] = useState(props.activeDate.year);
    let [menuItems, setMenuItems] = useState(true);
    let [menuItemsVissible, setMenuItemsVissible] = useState(false);



   // const [mobileMenuButton, setMobileMenuButton] = useState();
    
    const months = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const currentDate = new Date();

    useEffect(()=>{
        if(props.activeDate==null){
         setDay(currentDate.getDate());
         setMonth(currentDate.getMonth() + 1);
        setYear(currentDate.getFullYear());
        }else{

            setDay(props.activeDate.day);
            setMonth(props.activeDate.month);
           setYear(props.activeDate.year);
                
        }
        
    },[props.activeDate.day]);
    useEffect(()=>{
    setDay(currentDate.getDate());
    setMonth(currentDate.getMonth() + 1);
    setYear(currentDate.getFullYear());
    },[]);
    
    
    const [showCalendar, setshowCalendar] = useState(false);

    function handleShowCalendar(){
        if(showCalendar==false) {
            setshowCalendar(true);
        } else {
            setshowCalendar(false);
        }
    }
    /*
    console.log("menuItemsVissible");
    console.log(menuItemsVissible);
    var menuLinks = <></>;
    if(menuItemsVissible===true){
        menuLinks =  
    }else{
        menuLinks  = <></>;
        console.log();
    }
    */
    var showMenuLink = "";
    /*
    <ul id="menu-mobile-main" role="menubar">
        
    <li id="menu-item-124518" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-home current-menu-item page_item page-item-2 current_page_item menu-item-124518" role="none"><a href="/" aria-current="page" class="ct-menu-link" role="menuitem">Home</a></li>
    
    <li id="menu-item-124581" class="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-124581" role="none"><span class="ct-sub-menu-parent"><a href="/morning-live/" class="ct-menu-link" role="menuitem">Morning Live</a></span>

    </li>
    <li id="menu-item-124521" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-124521" role="none"><span class="ct-sub-menu-parent"><a href="/chch-podcasts/" class="ct-menu-link" role="menuitem">CHCH Podcasts</a></span>
    
    </li>
    <li id="menu-item-124548" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-124548" role="none"><a href="/shows/" class="ct-menu-link" role="menuitem">Shows</a></li>
    <li id="menu-item-124526" class="menu-item menu-item-type-post_type menu-item-object-page menu-item-124526" role="none"><a href="/contact-us/" class="ct-menu-link" role="menuitem">Contact Us</a></li>
    </ul>;
    */
     var hideMenuLink = <a href="/" ><img src="/wp-content/uploads/2024/03/CHCH_Pos_RGB_Logo.svg" width="40px"/></a>
    function showMobileMenu(){
   
        
        if(menuItemsVissible==false){
            console.log("Showing menu ");
            setMenuItemsVissible(true);

        }else{
        
      
        setMenuItemsVissible(false);
        }
      
    }
    console.log(menuItemsVissible);

    const [isVisible, setIsVisible] = useState(false); // State to track visibility

  // Function to toggle the visibility
  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };
        const lines= <><span></span>
        <span></span>
        <span></span></>;

        const cross = <span className="cross" >&#10006;</span>;
    return(
    <div id="navContainer">
        <nav class="navbar">
        
        <ul className="navbar-menu">
            <li><a onClick={handleShowCalendar}> 
                <p id="displayCalendarDate" >&#9660; {months[(month-1)] + " " + day + " " + year}</p>
            </a></li>
            
        </ul>
          
      
        </nav>

        <Calendar 

        setActiveDate={props.setActiveDate} 
        jsonRes={props.jsonRes}
        ScrollToAllShows={props.ScrollToAllShows} 
        showCalendar={showCalendar} handleShowCalendar={handleShowCalendar}/>
    </div>  
);

}
export default NavigationBar;